const ENProjectPhases = {
	"Copiar Ações": "Copy Actions",
	"Nenhuma fase encontrada": "No phase found",
	"Nenhuma fase adicionada": "No phase created"
};

export default ENProjectPhases;
